import React, { useEffect } from "react";
import DefaultButton from "../../styles/materialButtonStyle";
import { Input, InputLabel } from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import ValidationFormControl from "../../styles/materialValidFormControl";

import { StyledTwoFaWrapper } from "./styledTwoFa";
import { useTranslation } from "react-i18next";

const TwoFa = ({ handleSubmit, error }) => {
  const { t } = useTranslation("loginPage")

  const handleChange = (event) => {
    event.target.value = event.target.value.replace(/\D/g, "");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    document.getElementById("twofa").focus();
  }, []);

  return (
    <StyledTwoFaWrapper onSubmit={handleSubmit}>
      <ValidationFormControl
        error={error.email && true}
        className="twofa-field-group"
      >
        <InputLabel htmlFor="twofa">{t("twofaCode")}</InputLabel>
        <Input
          id="twofa"
          required
          type="twofa"
          name="twofa"
          inputProps={{ maxLength: 6 }}
          autoComplete="off"
          className="twofa-field-group__input"
          onInput={handleChange}
        />
        {error.twofa && <FormHelperText id="component-error-text">{error.twofa}</FormHelperText>}
      </ValidationFormControl>
      <div className="twofa-action">
        <DefaultButton
          color="success"
          type="submit"
        >
          {t("twofaConfirm")}
        </DefaultButton>
      </div>
    </StyledTwoFaWrapper>
  );
};

export default TwoFa;